import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: {
    fontSize: '14px',
    fontWeight: '400',
    color: 'red',
  },
}));

const LimitBanner = ({ show }) => {
  const classes = useStyles();

  if (!show) return null;

  return (
    <div className={ classes.root }>
      Your credits are exhausted. Contact the sales team.
    </div>
  );
};

export default LimitBanner;
